<template>
	<div class="page" >
		<!-- 搜索 -->
		<div class="pageTitleBox">
			<div class="boxNameL">
				宠物基本信息
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="msg" >
			<div class="msgItem" style="width:100%;">
				<div style="line-height: 16px;margin:12px 0;border-left:2px solid #F5882A;padding-left:3px;font-size: 14px;">宠物资料</div>
				<img style="width:14px;height:14px;margin:12px 5px;cursor: pointer;" src="../../../assets/img/edit.png" @click="openDialogAddEditPet"/>
			</div>
			<div class="msgItem">
				<div class="msgLabel">会员昵称：</div> <div class="msgValue">
					{{userDetail.basic_info.nick_name}}
					<span v-if="userDetail.lifeLong&&userDetail.lifeLong.status===1">
						<el-tooltip effect="dark" :content="userDetail.lifeLong.remark" placement="top-start">
							<img style="height: 16px;cursor: pointer;" src="../../../assets/img/zhong.png"/>
						</el-tooltip>
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">宠物昵称：</div> <div class="msgValue">
					{{curPet.nick_name}}
					<span v-if="curPet.lifeLong&&curPet.lifeLong.status===1">
						<el-tooltip effect="dark" :content="curPet.lifeLong.remark" placement="top-start">
							<img style="height: 16px;cursor: pointer;" src="../../../assets/img/zhong.png"/>
						</el-tooltip>
					</span>
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">种类：</div> <div class="msgValue">{{curPet.apply_type&&curPet.apply_type.title}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">品种：</div> <div class="msgValue">{{curPet.category_info&&curPet.category_info.name}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">毛色：</div> <div class="msgValue">{{curPet.pet_color}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">性别：</div> <div class="msgValue">{{curPet.pet_sex}}</div>
			</div>
			<div class="msgItem" >
				<div class="msgLabel">用具编号：</div> <div class="msgValue" v-if="userDetail.basic_info.birthday">{{curPet.tool_num}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">出生日期：</div> <div class="msgValue">{{curPet.bron_date}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">年龄：</div>
				<div class="msgValue">
					{{$public.FAge(curPet.bron_date)[0]}}岁
					{{$public.FAge(curPet.bron_date)[1]}}月
				</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">宠物芯片：</div> <div class="msgValue">{{curPet.eprom_no}}</div>
			</div>
			<div class="msgItem" style="width:50%;">
				<div class="msgLabel">体重：</div> <div class="msgValue">{{curPet.weight}} kg</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">体重说明：</div> <div class="msgValue">{{curPet.weight_remark}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">状态：</div> <div class="msgValue">{{curPet.status&&curPet.status.title}}</div>
			</div>
			<div class="msgItem">
				<div class="msgLabel">其他：</div> <div class="msgValue">{{curPet.sterilization===1?'已绝育':'未绝育'}}</div>
			</div>
		</div>
		<div class="tabLine">
			<!-- <div class="tabItem" :class="[curTabIndex==1?'active':'']" @click="changeTab(1)">绑定服务</div> -->
			<div class="tabItem" :class="[curTabIndex==2?'active':'']" @click="changeTab(2)">病例记录</div>
			<div class="tabItem" :class="[curTabIndex==3?'active':'']" @click="changeTab(3)">疫苗驱虫记录</div>
			<div class="tabItem" :class="[curTabIndex==4?'active':'']" @click="changeTab(4)">医疗服务记录</div>
			<!-- <div class="tabItem" :class="[curTabIndex==5?'active':'']" @click="changeTab(5)">寄养记录</div> -->
			<div class="tabItem" :class="[curTabIndex==6?'active':'']" @click="changeTab(6)">住院记录</div>
			<div class="tabItem" :class="[curTabIndex==7?'active':'']" @click="changeTab(7)">体重记录</div>
			<!-- <div class="tabItem" :class="[curTabIndex==8?'active':'']" @click="changeTab(8)">转移记录</div> -->
		</div>
		<div class="tableBox">
			<!-- <div class="table2" v-show="curTabIndex==1">
				<el-table class="table" :data="serviceList" style="width: 100%">
					<el-table-column prop="name" label="服务名称" :id="'weight'">
					</el-table-column>
					<el-table-column prop="consume_count" label="次数" width="400">
					</el-table-column>
					<el-table-column label="开始时间" width="400">
						<template slot-scope='scope'>
							{{$public.FTime(scope.row.start_time)}}
						</template>
					</el-table-column>
					<el-table-column label="有效期至" width="400">
						<template slot-scope='scope'>
							{{$public.FTime(scope.row.exprice_time)}}
						</template>
					</el-table-column>
				</el-table>
			</div> -->
			<!-- 病例记录 -->
			<div class="table2" v-show="curTabIndex==2">
				<el-table class="table" :data="illnessCase" style="width: 100%">
					<el-table-column prop="caseNumber" label="病例编号" >
					</el-table-column>
					<el-table-column prop="doctorName" label="医生" width="100">
					</el-table-column>
					<el-table-column prop="createTime" label="日期" width="160">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.createTime)}}
						</template>
					</el-table-column>
					<el-table-column prop="createUserName" label="添加人" width="200">
					</el-table-column>
					<el-table-column prop="createTime" label="添加时间" width="200">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.createTime)}}
						</template>
					</el-table-column>
					<el-table-column prop="shopName"  label="就诊地址" width="300">
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<el-button v-if="$buttonAuthority('huiyuan-see')" @click="toBingliSee(scope.row)" type="primary" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 疫苗驱虫 -->
			<div class="table2" v-show="curTabIndex==3">
				<el-table class="table" :data="servicePackagesList" style="width: 100%">
					<el-table-column label="编号" >
						<template slot-scope="scope">
							{{scope.row.id}}
						</template>
					</el-table-column>
					<el-table-column prop="servicePackageName" label="套餐名称" width="200">
					</el-table-column>
					<el-table-column label="类别" >
						<template slot-scope="scope">
							{{scope.row.serviceTypeId===1?'疫苗':'驱虫'}}
						</template>
					</el-table-column>
					<el-table-column prop="payMoney" label="金额" width="100">
					</el-table-column>
					<el-table-column prop="payType" label="支付方式" width="200">
						<template slot-scope="scope">
							{{scope.row.payType==1?'全额支付':''}}
							{{scope.row.payType==2?'计划支付':''}}
						</template>
					</el-table-column>
					<el-table-column prop="createUserName" label="添加人" width="150">
					</el-table-column>
					<el-table-column prop="createTime" label="添加时间" width="200">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.createTime)}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<el-button v-if="$buttonAuthority('huiyuan-see')" @click="toYMQCSee(scope.row)" type="primary" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :page="page_discount.page" :total="page_discount.total" @change="page_discountChange"></page>
			</div>
			<!-- 医疗服务 -->
			<div class="table3" v-show="curTabIndex==4">
				<el-table class="table" :data="medicalList" style="width: 100%">
					<el-table-column label="类别" >
						<template slot-scope="scope">
							{{scope.row.id}}
						</template>
					</el-table-column>
					<el-table-column prop="medicalServiceName" label="套餐名称" width="200">
					</el-table-column>
					<el-table-column prop="payMoney" label="金额" width="200">
					</el-table-column>
					<el-table-column prop="payType" label="支付方式" width="200">
						<template slot-scope="scope">
							{{scope.row.payType==1?'全额支付':''}}
							{{scope.row.payType==2?'计划支付':''}}
						</template>
					</el-table-column>
					<el-table-column prop="createUserName" label="添加人" width="150">
					</el-table-column>
					<el-table-column prop="createTime" label="添加时间" width="200">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.createTime)}}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="200">
						<template slot-scope="scope">
							<el-button v-if="$buttonAuthority('huiyuan-see')" @click="toYLFWSee(scope.row)" type="primary" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 寄养记录 -->
			<div class="table4" v-show="curTabIndex==5">
				<el-table class="table" :data="foster" style="width: 100%">
					<el-table-column prop="id" label="寄养编号" width="200">
					</el-table-column>
					<el-table-column prop="memberName" label="顾客" width="100">
					</el-table-column>
					<el-table-column prop="petNames" label="宠物" width="100">
					</el-table-column>
					<el-table-column prop="handlerName" label="经办人">
					</el-table-column>
					<el-table-column label="开始时间" width="200">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.beginDate)}}
						</template>
					</el-table-column>
					<el-table-column label="结束时间" width="200">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.endDate)}}
						</template>
					</el-table-column>
					<el-table-column label="时长" width="150">
						<template slot-scope="scope">
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[0]}}年
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[1]}}月
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[2]}}日
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[3]}}时
						</template>
					</el-table-column>
					<el-table-column label="状态" width="100">
						<template slot-scope="scope">
							{{scope.row.isPutOrder==false?'进行中':''}}
							{{scope.row.isPutOrder==true?'已结束寄养':''}}
						</template>
					</el-table-column>
					<el-table-column prop="shopName" label="寄养地点" width="200">
					</el-table-column>
					<el-table-column label="操作" width="100">
						<template slot-scope="scope">
							<el-button v-if="$buttonAuthority('huiyuan-see')" @click="$router.push({path:'/foster/fosterSee',query:{id:scope.row.id}})" type="primary" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :page="page.page" :total="page.total" @change="pageChange"></page>
			</div>
			<!-- 住院记录 -->
			<div class="table4" v-show="curTabIndex==6">
				<el-table class="table" :data="hospital" style="width: 100%">
					<el-table-column prop="id" label="编号" width="200">
					</el-table-column>
					<el-table-column prop="memberName" label="顾客">
					</el-table-column>
					<el-table-column prop="petNames" label="宠物" width="120">
					</el-table-column>
					<el-table-column prop="handlerName" label="经办人" width="100">
					</el-table-column>
					<el-table-column label="开始时间" width="160">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.beginDate)}}
						</template>
					</el-table-column>
					<el-table-column label="结束时间" width="160">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.endDate)}}
						</template>
					</el-table-column>
					<el-table-column label="时长" width="120">
						<template slot-scope="scope">
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[0]}}年
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[1]}}月
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[2]}}日
							{{$public.FAge(scope.row.beginDate,scope.row.endDate)[3]}}时
						</template>
					</el-table-column>
					<el-table-column label="状态" width="70">
						<template slot-scope="scope">
							{{scope.row.status!=2?'进行中':''}}
							{{scope.row.status==2?'已离院':''}}
						</template>
					</el-table-column>
					<el-table-column prop="shopName"  label="住院地点" width="150">
					</el-table-column>
					<el-table-column label="操作" width="80">
						<template slot-scope="scope">
							<el-button v-if="$buttonAuthority('huiyuan-see')" @click="toZhuyuanSee(scope.row)" type="primary" size="small">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :page="page_recharge.page" :total="page_recharge.total" @change="page_rechargeChange"></page>
			</div>
			<!-- 体重记录 -->
			<div class="table2" v-show="curTabIndex==7">
				<el-table class="table" :data="weightRecord" style="width: 100%">
					<el-table-column prop="weight" label="体重" :id="'weight'">
						<template slot-scope='scope'>
							{{scope.row.weight+'kg'}}
						</template>
					</el-table-column>
					<el-table-column prop="weight_reamrk" label="体重备注" width="400">
					</el-table-column>
					<el-table-column prop="user_name" label="经办人" width="400">
					</el-table-column>
					<el-table-column prop="zip" label="添加时间" width="300">
						<template slot-scope='scope'>
							{{$public.FTime(scope.row.create_time)}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 转移记录 -->
			<div class="table2" v-show="curTabIndex==8">
				<el-table class="table" :data="petTransferList" style="width: 100%">
					<el-table-column prop="weight" label="转移人" :id="'weight'">
						<template slot-scope='scope'>
							{{scope.row.transfer_info.member_name}}
						</template>
					</el-table-column>
					<el-table-column prop="weight_reamrk" label="转移时间" width="400">
						<template slot-scope='scope'>
							{{$public.FTime(scope.row.transfer_info.create_time)}}
						</template>
					</el-table-column>
					<el-table-column prop="user_name" label="接收人" width="400">
						<template slot-scope='scope'>
							{{scope.row.receive_info.member_name}}
						</template>
					</el-table-column>
					<el-table-column prop="zip" label="接收时间" width="200">
						<template slot-scope='scope'>
							{{$public.FTime(scope.row.receive_info.create_time)}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div v-if="dialogTransPet_state">
			<dialogTransPet :userId="userDetail._id" :pet="curPet" @submit="submit_transPet"></dialogTransPet>
		</div>
		<div v-if="dialogAddEditPet_state">
			<dialogAddEditPet :userInfo="userDetail" :petInfo="curPet" :dialog_type="'editPet'" @submit="dialogPet_submit"></dialogAddEditPet>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import dialogTransPet from '../../../components/dialog_transPet.vue'
	import dialogAddEditPet from '../../../components/drawer/drawer_addEditPetInfo.vue'
	export default {
		components: {
			page,dialogTransPet,dialogAddEditPet
		},
		data() {
			return {
				curTabIndex:2,
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				page_recharge: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				page_discount: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				orderList:[],
				orderRechargeList:[],
				discountList:[],
				depositList:[],
				
				total: 20,
				userDetail: {
					basic_info:{},
					card_info:{},
					company_info:{},
					pets_info:[],
					club_card:{}
				},
				time:'',
				formLabelWidth: '120px',
				orderType:-1,
				selectValue: '',
				// 
				illnessCase:[],
				foster:[],
				hospital:[],
				medicalList:[],
				servicePackagesList:[],
				// 宠物转移
				dialogTransPet_state:false,
				curPet:{},
				// 宠物修改
				dialogAddEditPet_state:false,
				// 宠物体重记录
				weightRecord:[],
				// 服务记录
				serviceList:[],
				// 转移记录
				petTransferList:[],
			}
		},
		computed: {
			bingliParams(){
				return this.$store.state.yiliaoxin.bingliParams;
			},
			ymqcParams(){
				return this.$store.state.yiliaoxin.ymqcParams;
			},
			ylfwParams(){
				return this.$store.state.yiliaoxin.ylfwParams;
			},
			zhuyuanParams(){
				return this.$store.state.yiliaoxin.zhuyuanParams;
			},
		},
		mounted(){
			if(this.$route.query.tab){
				this.curTabIndex = this.$route.query.tab
			}
			this.getUserDetail();
		},
		methods: {
			toBingliSee(row){
				let index = "/yiliaoxin/platform"
				let str = "医疗工作台"
				this.$store.commit("setCurNavIndex_"+index.split('/')[1],{title:str,path:index})
				this.$router.push({path:index})
				
				this.bingliParams.curRow = row
				this.bingliParams.type = "see"
				this.$store.commit("yiliaoxin/set_bingliParams",this.bingliParams)
				this.$store.commit('yiliaoxin/set_curBusiness','病例')
			},
			toYMQCSee(row){
				let index = "/yiliaoxin/platform"
				let str = "医疗工作台"
				this.$store.commit("setCurNavIndex_"+index.split('/')[1],{title:str,path:index})
				this.$router.push({path:index})
				
				this.ymqcParams.curRow = row
				this.ymqcParams.type = "see"
				this.$store.commit("yiliaoxin/set_ymqcParams",this.ymqcParams)
				this.$store.commit('yiliaoxin/set_curBusiness','疫苗驱虫')
			},
			toYLFWSee(row){
				let index = "/yiliaoxin/platform"
				let str = "医疗工作台"
				this.$store.commit("setCurNavIndex_"+index.split('/')[1],{title:str,path:index})
				this.$router.push({path:index})
				
				this.ylfwParams.curRow = row
				this.ylfwParams.type = "see"
				this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
				this.$store.commit('yiliaoxin/set_curBusiness','医疗服务')
			},
			toZhuyuanSee(row){
				let index = "/yiliaoxin/platform"
				let str = "医疗工作台"
				this.$store.commit("setCurNavIndex_"+index.split('/')[1],{title:str,path:index})
				this.$router.push({path:index})
				
				this.zhuyuanParams.curRow = row
				this.zhuyuanParams.type = "see"
				this.$store.commit("yiliaoxin/set_zhuyuanParams",this.zhuyuanParams)
				this.$store.commit('yiliaoxin/set_curBusiness','住院')
			},
			// tab切换
			changeTab(a){
				if(this.curTabIndex!=a){
					this.$router.replace({path:'/huiyuan/huiyuanPetSee',query:{uid:this.$route.query.uid,pid:this.$route.query.pid,tab:a}})
					this.curTabIndex=a;
					this.page.page=1;
				}
			},
			getUserDetail(){
				let params = {
					"id": this.$route.query.uid,
				}
				this.$http.get('/api/Member/Single', params).then(res => {
					if(res.code==0){
						this.userDetail = res.data;
						for(let i=0;i<this.userDetail.pets_info.length;i++){
							if(this.userDetail.pets_info[i]._id===this.$route.query.pid){
								this.curPet=this.userDetail.pets_info[i];
								this.weightRecord = this.curPet.weight_records.reverse();
							}
						}
						this.getList();
						this.getServicePackagesList();
						this.getMedicalList();
					}
				})
			},
			// 获取病例 住院 寄养
			getList(){
				this.$http.post('/api/Case/List', {
					"petId": this.$route.query.pid,
					"pageIndex": 1,
					"pageSize": 1000,
				}).then(res => {
					if (res.code == 0) {
						this.illnessCase = res.data.data;
					}
				})
				this.$http.post('/api/InHospital/List', {
					typeId:1,
					"petId": this.$route.query.pid,
					"pageIndex": 1,
					"pageSize": 1000,
				}).then(res => {
					if (res.code == 0) {
						this.foster = res.data.data;
					}
				})
				this.$http.post('/api/InHospital/List', {
					typeId:2,
					"petId": this.$route.query.pid,
					"pageIndex": 1,
					"pageSize": 100,
				}).then(res => {
					if (res.code == 0) {
						this.hospital = res.data.data;
					}
				})
				// this.getPetTransferList();  // 8010 没有对应接口
			},
			// 服务
			// getServiceList(){
			// 	this.$http.get('/api/Pet/BindServiceList', {
			// 		"petId": this.$route.query.pid,
			// 	}).then(res => {
			// 		if (res.code == 0) {
			// 			this.serviceList = res.data;
			// 		}
			// 	})
			// },
			// 医疗服务
			getMedicalList(){
				this.$http.post('/api/MedicalService/List', {
					"petId": this.$route.query.pid,
					"payType": 0,   // 1全额支付；2计划支付
					"pageIndex": 1,
					"pageSize": 500,
					"keyword": ""
				}).then(res => {
					if (res.code == 0) {
						this.medicalList = res.data.data;
					}
				})
			},
			// 疫苗 驱虫
			getServicePackagesList(){
				this.$http.post('/api/MedicalPackage/List', {
					"petId": this.$route.query.pid,
					"serviceTypeId": -1,  // 1疫苗；2驱虫;
					"payType": 0,   // 1全额支付；2计划支付
					"pageIndex": 1,
					"pageSize": 500,
					"keyword": ""
				}).then(res => {
					if (res.code == 0) {
						this.servicePackagesList = res.data.data;
					}
				})
			},
			handleClick(row) {
				console.log(row);
			},
			// 页码改变
			pageChange(a) {
				this.page.page=a;
				this.getUserOrderList(this.userDetail._id)
			},
			// 页码改变
			page_rechargeChange(a) {
				this.page_recharge.page=a;
				this.getUserOrderRechargeList(this.userDetail._id)
			},
			// 页码改变
			page_discountChange(a) {
				this.page_discount.page=a;
				this.getUserDiscountList(this.userDetail._id)
			},
			
			// 退款
			refund(a) {
				alert(a)
			},
			// 修改宠物
			openDialogAddEditPet(){
				this.dialogAddEditPet_state=true;
			},
			dialogPet_submit(data){
				this.dialogAddEditPet_state = false;
				if(data!=='close'){
					this.getUserDetail();
				}
			},
			// 转移宠物
			trans(row){
				this.curPet = row;
				this.dialogTransPet_state=true;
			},
			submit_transPet(){
				this.dialogTransPet_state=false;
				this.getUserDetail();
			},
			// 转移记录
			getPetTransferList(){
				this.$http.get('/api/Pet/PetTransferList', {
					"petId": this.$route.query.pid,
				}).then(res => {
					if (res.code == 0) {
						this.petTransferList = res.data.data;
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		.pageTitleBox{
			
		}
		.searchLine {
			background-color: #fff;
			.search {
				display: flex;
				justify-content: space-between;
				padding-bottom: 20px;
				.searchL {
					width:1200px;
					.tit{
						padding-left:10px;
						border-left: 3px solid #FFD138;
						margin-top:18px;
						display: inline-block;
					}
				}
				.searchR {
					.nav{
						display: flex;
						.navItem{
							width:102px;
							line-height: 37px;
							border-radius: 4px;
							text-align: center;
							color:#1A1A1A;
							font-size: 16px;
							margin-left:30px;
							cursor: pointer;
							&.active{
								background-color: #FFD138;
							}
						}
					}
				}
			}
		}
		
		.msg{
			display: flex;
			flex-wrap: wrap;
			background-color: #fff;
			border-radius: 4px;
			.msgItem {
				width: 25%;
				font-size: 16px;
				color: $fontColor;
				display: flex;
				line-height: 40px;
				padding:0 20px;
				border-bottom:1px solid #F2F2F2;
				font-size: 12px;
				box-sizing: border-box;
				.msgLabel {
					width: 80px;
					text-align: right;
					color: $fontColor;
				}
			
				.msgValue {}
			}
		}
		.tabLine{
			margin-top: 12px;
			display: flex;
			
			.tabItem {
				padding: 0 16px;
				line-height: 36px;
				text-align: center;
				border-right: 1px solid #F2F2F2;
				cursor: pointer;
				font-size: 14px;
				background-color: #fff;
				&.active {
					color: $mainColor;
				}
			}
		}
		.table {
			min-height: 400px;
		}
		.tableBox{
			border-top: 1px solid #F2F2F2;
		}
	}
</style>
